export default __webpack_public_path__ + "static/media/bsc-tag-white.1435060c.svg";